import React from 'react'
import { storiesOf } from '@storybook/react'
import { Match as MatchProto, MatchStatus, Team } from 'protos'
import Match from 'components/Match'

const exampleMatch = MatchProto.create({
  homeTeam: Team.create({ name: 'Chelsea' }),
  awayTeam: Team.create({ name: 'Manchester United' }),
})

storiesOf('Match', module)
  .add('pre match', () => (
    <Match
      match={{
        ...exampleMatch,
        status: MatchStatus.MS_UPCOMING
      }}
    />
  ))
  .add('during match', () => (
    <Match
      match={{
        ...exampleMatch,
        status: MatchStatus.MS_LIVE,
        currentScore: '1 - 0'
      }}
    />
  ))
  .add('after match', () => (
    <Match
      match={{
        ...exampleMatch,
        status: MatchStatus.MS_FINISHED,
        currentScore: '1 - 12'
      }}
    />
  ))
